[
    {
        "code": "V181",
        "name": "Vivere",
        "rank": "1",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/E1AoK7R5Ovw",
        "tagline": "#Stay Lovely and Loved<br><br>Vivere is designed to help those who suffer from suicidal thoughts. In this app we have included some features such as game (pet and the garden), relax me, music, chatting with volunteers or professionals, doing psychological tests and emergency contact system."
    },
    {
        "code": "V173",
        "name": "Rise",
        "rank": "2",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/k3cNXTeM9j0",
        "tagline": "Rise is more than a suicide prevention app. It is also a virtual friend who cares about you. It tracks your daily mood, communicates with you, allows you to share your thoughts and entertains you with video and music. Let us help you bring balance, peace and joy in your life and rise again."
    },
    {
        "code": "V082",
        "name": "FarmieTales",
        "rank": "3",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/Mx93HIaPrmE",
        "tagline": "Planting a better Tomorrow!"
    },
    {
        "code": "V279",
        "name": "AlpacaHelp",
        "rank": "4",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/FRCsFZAZ3E8",
        "tagline": "AlpacaHelp aims to simplify and shorten the donation process all in one system. This is to give a final push to individuals who already have their heart in the right place but are still hesitant. Linking everyone together creates a seamless ecosystem that can garner a larger userbase."
    },
    {
        "code": "V277",
        "name": "FLOWAVE",
        "rank": "5",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/DqIewU69rLU",
        "tagline": "FLOWAVE is a project that utilizes AI drainage system(IoT sensors ), geographical information system(GIS), and neural network. We provide flashflood forecasts, flashflood preemptive measures, and flashflood rescue. This helps leverage public flashflood awareness and saves people's lives."
    },
    {
        "code": "V130",
        "name": "Agroo Project",
        "rank": "6",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/UpUg2_u_G7Y",
        "tagline": "Agroo Market App is an all-in-one platform for the agricultural industry to connect with consumers, farmers and agencies designed to eliminate redundancies that has led to the decrease in food security. Its marketplace allows users to buy and sell their crop goods online."
    },
    {
        "code": "V213",
        "name": "FloodID",
        "rank": "7",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/7WZEYnP7aJQ",
        "tagline": "Prepare | Evacuate | Mitigate"
    },
    {
        "code": "V067",
        "name": "KekalFresh",
        "rank": "8",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/_Q9F-5y2foM",
        "tagline": "A platform that gets customers connected with fresh food suppliers\r\n"
    },
    {
        "code": "V122",
        "name": "Relivio",
        "rank": "9",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/UXm0yueTBfw",
        "tagline": "know, reflect, and connect to yourself with Relivio"
    },
    {
        "code": "V221",
        "name": "E-Belajar",
        "rank": "10",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/-CIqjg2ftUg",
        "tagline": "E-Belajar is aimed to completely remove the teachers out of the equation of learning. Made for high school students, they can freely learn according to their pace with our fully guided exam questions, illustrative notes and AR quizzes."
    },
    {
        "code": "V066",
        "name": "Charicity",
        "rank": "11",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/VQOvNK8Ts2s",
        "tagline": "\"Buy as a Donation\", the modern way of charity"
    },
    {
        "code": "V244",
        "name": "Fresh",
        "rank": "12",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/ioIdVNcr5Aw",
        "tagline": "Fresh, An apps that truly empowering harvest in Malaysia."
    },
    {
        "code": "V143",
        "name": "GiveBack",
        "rank": "13",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/dHPgchZArac",
        "tagline": "GiveBack is a mobile application that aims to build a channel between different slides of the communities.\r\n"
    },
    {
        "code": "V241",
        "name": "VFlagg",
        "rank": "14",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/S2TbGLddluU",
        "tagline": "VFlagg, a mobile application designed by V241, is a platform to link-up donors with recipients. This application contains several features such as an independent foundation, a special task-to-point system and collaboration partners. Most importantly, the recipient's identity is always concealed.\r\n"
    },
    {
        "code": "V078",
        "name": "AgriChain",
        "rank": "15",
        "type": "top15",
        "projectlink": "https://www.youtube.com/embed/oDhX4MFg_LE",
        "tagline": "Demand influences the price of the product. To solve that, we develop a system using Blockchain technology to stabilize the demand for each food product. Our goal is to make the food supply chain transparent, affordable, available and safe."
    },
    {
        "code": "V001",
        "name": "AssignMe!",
        "type": "usm",
        "projectlink": "https://www.youtube.com/embed/gFwlAOsq9iE",
        "tagline": "\"Where Your Assignment Worries Fade Away...\r\nAssignMe is a student-oriented matchmaking platform for coursework assignments that groups together compatible and like-minded individuals to assemble the perfect team.\""
    },
    {
        "code": "V082",
        "name": "FarmieTales",
        "type": "popular",
        "projectlink": "https://www.youtube.com/embed/Mx93HIaPrmE",
        "tagline": "Planting a better Tomorrow!"
    },
    {
        "code": "V226",
        "name": "Agro Grid",
        "type": "xilnex",
        "projectlink": "https://www.youtube.com/embed/hdZ_FX3t-0A",
        "tagline": "Use Less to Grow More. Agro Grid is a one-stop smart solution for farmers and agronomists to monitor and manage crop production, organize team members, and forecast weather to boost crop production while ensuring efficient fertilizer and water management."
    },
    {
        "code": "V143",
        "name": "GiveBack",
        "type": "business",
        "projectlink": "https://www.youtube.com/embed/dHPgchZArac",
        "tagline": "GiveBack is a mobile application that aims to build a channel between different slides of the communities.\r\n"
    }
]